import React, { useState } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { X, Mail, Lock, Loader2, ShieldCheck, AlertCircle } from 'lucide-react';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError(null);

    try {
      /* console removed */

      const { data, error } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password,
      });

      if (error) throw error;
      if (!data.session) throw new Error('Session not created');

      /* console removed */

      /**
       * 🔑 PENTING
       * Jangan redirect
       * Jangan reload
       * Jangan panggil requireSession
       *
       * AuthContext / onAuthStateChange akan handle sisanya
       */
      onClose();
    } catch (err: any) {
      /* console removed */
      setError(err.message || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-slate-900/60 z-[100] flex items-center justify-center p-4 backdrop-blur-md"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-[3rem] w-full max-w-md p-10 shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-8 right-8 text-slate-400 hover:text-slate-900"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center mb-10">
          <div className="w-20 h-20 bg-indigo-50 text-indigo-600 rounded-[2rem] flex items-center justify-center mx-auto mb-6">
            <ShieldCheck className="w-10 h-10" />
          </div>
          <h3 className="font-black text-3xl uppercase">DELTA PORTAL</h3>
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-2">
            Secure Login
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          {error && (
            <div className="bg-rose-50 text-rose-600 p-4 rounded-2xl flex items-center gap-3 text-xs font-bold">
              <AlertCircle className="w-4 h-4" />
              {error}
            </div>
          )}

          <div>
            <label className="text-[10px] font-black text-indigo-600 uppercase ml-3">Email</label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-300" />
              <input
                type="email"
                required
                className="w-full bg-slate-50 pl-12 pr-4 py-4 rounded-2xl outline-none font-bold"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="text-[10px] font-black text-indigo-600 uppercase ml-3">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-300" />
              <input
                type="password"
                required
                className="w-full bg-slate-50 pl-12 pr-4 py-4 rounded-2xl outline-none font-bold"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 text-white py-5 rounded-[2rem] font-black uppercase tracking-widest flex justify-center items-center gap-3"
          >
            {loading ? (
              <Loader2 className="animate-spin w-6 h-6" />
            ) : (
              <ShieldCheck className="w-6 h-6" />
            )}
            {loading ? 'MEMVERIFIKASI...' : 'MASUK'}
          </button>
        </form>
      </div>
    </div>
  );
};
